module.exports = {
	publicPath: process.env.NODE_ENV === 'production'
    ? '/vvl/'
    : '/',
  runtimeCompiler: true,
};
